module.exports = __webpack_public_path__ + "img/car.98c1e743.png";